import { ReduxAction } from '../../constants';
const initialState = {};

const jobFunctionDesignationReducer = (state = initialState, action) => {
  switch (action.type) {
    case ReduxAction.jobFuncDesignation: {
      return {
        ...state,
        ...action.payload,
      };
    }
    default:
      return state;
  }
};
export default jobFunctionDesignationReducer;
